import React from 'react';
import { FlatList } from 'react-native';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { View } from '../../View';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
import { Divider } from '../../Divider';
import { Template } from './Template';
export const List = ({ style, data, onEdit, onDelete, onSend, pid }) => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(View, { style: styles.header },
            React.createElement(Icon, { name: 'chat', filled: true, size: size.G, color: (color) => color.invert2.p100 }),
            React.createElement(Text, { type: 'headline', size: 'md', style: styles.title }, "Message templates")),
        React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
        React.createElement(FlatList, { data: data, style: styles.main, contentContainerStyle: styles.content, keyExtractor: (item) => item.id, renderItem: ({ item }) => (React.createElement(Template, { data: item, isEditingEnabled: item.author === pid, onDelete: onDelete, onEdit: onEdit, onSend: onSend })), ItemSeparatorComponent: () => (React.createElement(Divider, { type: 'horizontal', style: styles.separator })) })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        padding: size.C,
        paddingBottom: 0,
        backgroundColor: color.bg.v3,
        borderRadius: size.G,
        width: 280,
        height: 480
    },
    header: {
        padding: size.B,
        paddingLeft: size.E,
        flexDirection: 'row',
        alignItems: 'center'
    },
    title: {
        color: color.invert2.p100,
        flex: 1,
        marginHorizontal: size.C
    },
    divider: {
        marginHorizontal: size.E,
        marginTop: size.C
    },
    separator: {
        marginLeft: size.E
    },
    main: {
        flex: 1,
        marginRight: -size.C,
        paddingRight: size.C - size.A
    },
    content: {
        paddingBottom: size.C
    }
}));
//# sourceMappingURL=List.js.map